angular.module('impactx.combibudget').controller('CombiBudgetCTUListCtrl', [
    '$routeParams',
    CombiBudgetCTUListCtrl
]);

function CombiBudgetCTUListCtrl($routeParams) {

    this.meta = {
        rowTemplate: 'modules/combibudget/templates/ctulist.row.tmpl.html',
        headerTemplate: 'modules/combibudget/templates/headerSummary.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/combibudget/ctulist',
        id: "combibudgetctulist",
        excelExport: true,
        params: {
            id: $routeParams.id
        },
        valuesInteger: [{name: "id", value: $routeParams.id}]
    };

    this.getMeta = function () {
        return this.meta;
    };
}